import React from "react";
import Hero from "../components/Hero.jsx";
import About from "../components/About.jsx";
import InteractiveSkills from "../components/InteractiveSkills.jsx";
import Experience from "../components/Experience.jsx";
import Work from "../components/Work.jsx";
import OtherProjects from "../components/OtherProjects.jsx";
import Contact from "../components/Contact.jsx";
import Footer from "../components/Footer.jsx";
import ScrollProgress from "../components/ui/ScrollProgress.jsx";

const Home = () => {
  return (
    <div className="bg-navy text-white">
      <ScrollProgress />
      
      {/* Hero Section */}
      <Hero />

      {/* About Section */}
      <About />

      {/* Interactive Skills Section */}
      <InteractiveSkills />

      {/* Experience Section */}
      <Experience />

      {/* Work Section */}
      <Work />

      {/* Other Projects Section */}
      <OtherProjects />


      {/* Contact Section */}
      <Contact />

      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default Home;
